<template>
  <div>
    <progress-bar class="c-progress-header" :value="4" :max="6" label="stappen">Progress</progress-bar>
    <h1 class="c-heading-1">Hoe is de scan opgebouwd?</h1>
    <p>Bij de start van elke trend meten we via 2 vragen hoe belangrijk en hoe impactvol jij die trend op je activiteit inschat. Per trend focust de FutureForward-scan zich op 3 thema’s, namelijk Zingeving, Menselijke factor, en Performantie.</p>
    <p>Je krijgt per trend 1 tot maximaal 6 vragen. Het aantal vragen hangt precies af van het belang dat je zelf aan de trend toekent. Bij elke vraag geef je een score van 1 tot 10.</p>
    <input-group label="Vul nu het aantal medewerkers in en wij passen de vragen over de menselijke factor aan jouw situatie aan.">
      <select :id="uniqueId" v-model="coworkers" slot-scope="{ uniqueId }">
        <option v-for="(value, index) in coworkerValues" :value="index">{{value}}</option>
      </select>
    </input-group>
    <div class="c-toolbar">
      <navigation-button to="inforesults" @click="submitCoworkers">Ga verder</navigation-button>
    </div>
  </div>
</template>

<script>
import InputGroup from '../components/InputGroup'
import NavigationButton from '../components/NavigationButton'
import ProgressBar from '../components/ProgressBar'
import coworkersMixin from "../mixins/Coworkers.js";
export default {
  mixins: [coworkersMixin],
  components: {
    InputGroup,
    NavigationButton,
    ProgressBar
  },
  data () {
    return {
      coworkers: 0
    }
  },
  methods: {
    submitCoworkers () {
      this.$store.commit('updateCoworkers', this.coworkers)
      this.$store.commit('updateProgress', 'COWORKERS_COMPLETED')
      this.$store.dispatch('updateDatabaseRecord')
    }
  }
}
</script>
